import type { ChildTableHeaderProps } from "./types";

/**
 * Column headers rendering
 */
export function ChildTableHeader({ fields }: ChildTableHeaderProps) {
  if (fields.length === 0) {
    return null;
  }

  return (
    <div
      className="grid gap-4 px-4 py-3 bg-muted/50 border-b sticky top-0 z-10"
      style={{
        gridTemplateColumns: `repeat(${fields.length}, minmax(0, 1fr)) auto`,
      }}
    >
      {fields.map((field) => (
        <div key={field.fieldname} className="font-semibold text-sm">
          {field.label}
          {field.reqd === 1 && <span className="text-destructive ml-1">*</span>}
        </div>
      ))}
      <div className="flex items-center justify-center">
        <span className="text-sm font-semibold text-muted-foreground">Actions</span>
      </div>
    </div>
  );
}












